// extracted by mini-css-extract-plugin
export var active = "_eb-7";
export var container = "_eb-0";
export var evenWidth = "_eb-4";
export var large = "_eb-5";
export var outlet = "_eb-8";
export var slide = "_eb-2";
export var small = "_eb-6";
export var tab = "_eb-3";
export var tabs = "_eb-1";